import { createContext, useContext } from "react";
import { defined } from "../../../../../../shared/utilities/typeHelper";

export type ChartOfAccountsContextItem = {
  parent: ChartOfAccountsContextItem | null;
  children: ChartOfAccountsContextItem[];
  identifier: string;
  checked: boolean;
  indeterminate: boolean;
  accountNo?: string | undefined;
};

interface ContextValue {
  appendChild: (key: string, node: ChartOfAccountsContextItem, accountNo?: string) => void;
  getNode: (key: string, node: ChartOfAccountsContextItem | null) => ChartOfAccountsContextItem | null;
  onSelect: (key: string, selected: boolean) => void;
  resetSelectedAccounts: () => void;
  scrollToAccountNo: (node: ChartOfAccountsContextItem) => void;
  root: ChartOfAccountsContextItem;
  selectedAccounts: string[];
  scrollTargetAccount: { accountNo: string } | undefined;
}

export const ChartOfAccountsContext = createContext<ContextValue | undefined>(undefined);

export const useChartOfAccountsContext = () => {
  const context = useContext(ChartOfAccountsContext);
  return defined(context);
};
